module.exports = __webpack_public_path__ + "img/aboutUs_img15.adb9a4a5.svg";